import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const UnderlineIcon = (props?: SvgProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <path
      d="M4.5 3V7.5C4.5 8.69347 4.97411 9.83807 5.81802 10.682C6.66193 11.5259 7.80653 12 9 12C10.1935 12 11.3381 11.5259 12.182 10.682C13.0259 9.83807 13.5 8.69347 13.5 7.5V3"
      stroke="#6B7280"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 15H15"
      stroke="#6B7280"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
